import { InjectionToken } from '@angular/core';
import { NgControl } from '@angular/forms';

export interface FormErrorsFormatter {
  format(control: NgControl): string;
}

export const FORM_ERRORS_FORMATTER = new InjectionToken<FormErrorsFormatter>('FORM_ERRORS_FORMATTER');
